import Keycloak from 'keycloak-js';


let keycloakInstance: Keycloak | null = null;
let initPromise: Promise<boolean> | null = null;

const AUTH_HINT_KEY = 'interview-auth-hint';
export const AUTH_HINT_EVENT = 'interview-auth-hint-change';

export function hasInterviewAuthHint(): boolean {
  try {
    return window.localStorage.getItem(AUTH_HINT_KEY) === '1';
  } catch {
    return false;
  }
}

export function hasOAuthCallbackInUrl(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has('code') && params.has('state')) return true;
    const hash = window.location.hash.replace(/^#/, '');
    if (!hash) return false;
    const hashParams = new URLSearchParams(hash);
    return hashParams.has('code') && hashParams.has('state');
  } catch {
    return false;
  }
}

function setInterviewAuthHint(value: boolean): void {
  try {
    const prev = window.localStorage.getItem(AUTH_HINT_KEY);
    const next = value ? '1' : null;
    if (prev === next) return;
    if (next === null) {
      window.localStorage.removeItem(AUTH_HINT_KEY);
    } else {
      window.localStorage.setItem(AUTH_HINT_KEY, next);
    }
    window.dispatchEvent(new Event(AUTH_HINT_EVENT));
  } catch {
    // localStorage недоступен (приватный режим/SSR) — молча игнорируем
  }
}

export function getKeycloak(): Keycloak {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      url: process.env.REACT_APP_KEYCLOAK_URL!,
      realm: process.env.REACT_APP_KEYCLOAK_REALM!,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID!,
    });
  }

  return keycloakInstance;
}

export async function initInterviewAuth(): Promise<boolean> {
  if (initPromise) {
    return initPromise;
  }

  const keycloak = getKeycloak();

  initPromise = keycloak.init({
    onLoad: "check-sso",
    pkceMethod: "S256",
    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    // Иногда полезно отключить iframe-проверку, если есть странности в браузерах:
    // checkLoginIframe: false,
  });

  try {
    const authenticated = await initPromise;
    setInterviewAuthHint(authenticated);
    return authenticated;
  } catch (error) {
    initPromise = null;
    throw error;
  }
}

export async function requireInterviewLogin(): Promise<void> {
  const keycloak = getKeycloak();

  const authenticated = await initInterviewAuth();

  if (!authenticated) {
    await keycloak.login({
      redirectUri: window.location.href,
    });
  }
}

export async function loginInterview(): Promise<void> {
  await initInterviewAuth();
  return getKeycloak().login({
    redirectUri: window.location.href,
  });
}

export async function getAccessToken(): Promise<string> {
  const keycloak = getKeycloak();

  if (!keycloak.authenticated) {
    throw new Error("User is not authenticated");
  }

  await keycloak.updateToken(30);

  if (!keycloak.token) {
    throw new Error("Access token is missing");
  }

  return keycloak.token;
}

export function logoutInterview(): Promise<void> {
  const keycloak = getKeycloak();

  setInterviewAuthHint(false);

  return keycloak.logout({
    redirectUri: `${window.location.origin}/`,
  });
}